export const closeOnEscapeKeyDown = closeFunction =>
  document.body.addEventListener('keydown', onKeyDown => {
    if (event.keyCode === 27 /* Escape */) {
      closeFunction()
    }
  })
